import { createStore } from 'vuex';

export default createStore({
  state: {
    userInfo: {
      name: '',
      account: '',
    },
  },
  mutations: {
    setUser(state, user) {
      state.userInfo = user;
    },
  },
  getters: {
    getUserInfo: (state) => state.userInfo,
  },
  actions: {
    getUser() {
      return this.state.userInfo;
    },
  },
  modules: {
  },
});
